import React from 'react';
import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AccountType } from './accounts-reducer';

type AccountItemPropsType = {
  account: AccountType
}

export type AccountLocationStateType = {
 accountId: number
}

export const AccountItem = (props: AccountItemPropsType) => {
  const navigate = useNavigate()

  const accountLocationState: AccountLocationStateType = {
    accountId: props.account.id
  }

  const removeAccount = () => {
    alert('REmove')
  }
  return (
    <TableRow hover key={props.account.id} className='accountItem' onClick={() => navigate(`/accountsList/${props.account.id}`, { state: accountLocationState })} >
    <TableCell style={{ textAlign: 'center' }}>
      <Typography >
      {props.account.id}
      </Typography>
    </TableCell>
    <TableCell >
      <Typography className='accountItem'>
      {props.account.name}
      </Typography>
    </TableCell>
    <TableCell style={{ textAlign: 'center'}}>
      <Typography>
        {props.account.email}
      </Typography>
    </TableCell>
    <TableCell style={{ textAlign: 'center' }}>
      <Typography>
      {props.account.users.length}
      </Typography>
    </TableCell>
    <TableCell style={{ textAlign: 'center' }}>
      <Typography>
        {props.account.isActive ? 'active' : 'not active'}
      </Typography>
    </TableCell>
  </TableRow>
  )
}